import { IPagination } from "./user";

export type ConfigType = ConfigTypeSingle[];
export type ConfigTypeSingle = {
  facetName: string;
  title: string;
  isSearchable: boolean;
  compType:
    | "list"
    | "inputRange"
    | "slider"
    | "custom-multi-select"
    | "checkbox"
    | "custom-multi-inputRange"
    | "star";

  desc: string;

  placeHolder?: string;
  fType: "creator" | "audience" | "performance" | "content";
  maxCount?: number;
  type?: string;
  hideFilter?: boolean;
  optionsList?: any[];
};

export const IGFilters: ConfigType = [
  {
    facetName: "follower",
    title: "Followers",
    isSearchable: false,
    compType: "inputRange",
    desc: "Filter creators by follower count",
    placeHolder: "",
    fType: "creator",
    hideFilter: true
  },
  {
    facetName: "creatorAge",
    title: "Creator's Age",
    isSearchable: false,
    compType: "inputRange",
    desc: "Filter creators by creator's age.",

    placeHolder: "",
    fType: "creator",
  },
  {
    facetName: "isVerified",
    title: "Is verified?",
    isSearchable: false,
    compType: "checkbox",
    desc: "Filter creators by platform verification status.",

    placeHolder: "",
    fType: "creator",
  },
  {
    facetName: "creatorLanguage",
    title: "Creator's language",
    isSearchable: true,
    compType: "list",
    desc: "Filter creators by creators language.",
    type: "multiple",

    placeHolder: "Search Language",
    fType: "creator",
  },
  {
    facetName: "bioPhrases",
    title: "Bio phrase",
    isSearchable: true,
    compType: "list",
    desc: "Filter creators by the phrase they use in their bio.",
    fType: "creator",
    placeHolder: "Search keywords in bio of the creator",
    type: "tags",
  },
  // {
  //   facetName: "category",
  //   title: "Category",
  //   isSearchable: true,
  //   compType: "list",
  //   desc: "Filter creators by category",
  //   fType: "creator",
  //   placeHolder: "Search by creator category",
  //   type: "tags",
  // },
  {
    facetName: "location",
    title: "Location",
    isSearchable: true,
    compType: "list",
    desc: "Filter creators by creators location.",
    placeHolder: "Search location",
    fType: "creator",
    type: "multiple",
    hideFilter: true
  },
  {
    facetName: "creatorGender",
    title: "Creator's Gender",
    isSearchable: false,
    compType: "list",
    desc: "Filter creators by gender of the creator.",
    placeHolder: "Select gender",
    fType: "creator",
  },
  // {
  //   facetName: "creatorType",
  //   title: "Creator Type",
  //   isSearchable: false,
  //   compType: "list",
  //   desc: "Filter creators by category",

  //   fType: "creator",
  //   placeHolder: "Search by creator category",
  // },

  {
    facetName: "audienceLocations",
    title: "Top Audience Location",
    isSearchable: true,
    compType: "custom-multi-select",
    desc: "Filter creators who's audience is from the selected location.",

    placeHolder: "Search country or city",
    fType: "audience",
  },

  {
    facetName: "audienceAge",
    title: "Audience Age",
    isSearchable: true,
    compType: "custom-multi-select",
    desc: "Filter creators by audience age.",
    placeHolder: "Search age groups",
    fType: "audience",
  },
  {
    facetName: "audienceGender",
    title: "Audience Gender",
    isSearchable: true,
    compType: "custom-multi-select",
    desc: "Filter creators by gender of the audience.",

    placeHolder: "Search Gender",
    fType: "audience",
  },

  {
    facetName: "contentKeywords",
    title: "Keywords",
    isSearchable: true,
    compType: "list",
    desc: "Filter creators by keywords that can be found in creator's posts captions.",
    type: "tags",

    fType: "content",
    placeHolder: "Search by keyword",
  },
  {
    facetName: "recentPost",
    title: "Recent Post",
    isSearchable: false,
    compType: "list",
    desc: "Filter creators who posted content in the selected time frame. ",
    placeHolder: "Select time frame",
    fType: "content",
  },
  {
    facetName: "hashtags",
    title: "Hashtags",
    isSearchable: true,
    compType: "list",
    desc: "Shows creators who have mentioned the added hashtags in their posts. ",
    placeHolder: "Search By Hashtags",
    type: "tags",

    fType: "content",
    maxCount: 20,
  },
  {
    facetName: "mentions",
    title: "Mentions",
    isSearchable: true,
    compType: "list",
    desc: "Shows creators who have mentioned the added usernames in their posts. ",
    placeHolder: "Search by Mentions",
    type: "tags",

    fType: "content",
    maxCount: 20,
  },
  {
    facetName: "avgReelViews",
    title: "Average Reel Views",
    isSearchable: false,
    compType: "inputRange",
    desc: "Filter creators by minimum average reels views.",
    placeHolder: "Enter min/max views",
    fType: "performance",
  },
  {
    facetName: "engRate",
    title: "Engagement Rate",
    isSearchable: false,
    compType: "slider",
    desc: "Filter creators by engagement rates.",
    placeHolder: "Select engagement rate range",
    fType: "performance",
  },
  {
    facetName: "avgLikes",
    title: "Average Likes",
    isSearchable: false,
    compType: "inputRange",
    desc: "Filter creators by average likes.",
    placeHolder: "Enter min/max likes",
    fType: "performance",
  },
  // {
  //   facetName: "rating",
  //   title: "Rating",
  //   isSearchable: false,
  //   compType: "star",
  //   desc: "Filter creators by creator's rating",
  //   placeHolder: "Select rating",
  //   fType: "creator",
  // },
];

export const YtFilters: ConfigType = [
  {
    facetName: "follower",
    title: "Subscribers",
    isSearchable: false,
    compType: "inputRange",
    desc: "Filter creators by follower count",
    placeHolder: "Enter min/max subscribers",
    fType: "creator",
    hideFilter: true,
  },

  // {
  //   facetName: "category",
  //   title: "Category",
  //   isSearchable: true,
  //   compType: "list",
  //   desc: "Filter creators by category",
  //   type: "tags",

  //   fType: "creator",
  //   placeHolder: "Search by creator category",
  // },
  {
    facetName: "location",
    title: "Location",
    isSearchable: true,
    compType: "list",
    desc: "Filter creators by creators location.",
    placeHolder: "Search location",
    fType: "creator",
    type: "multiple",
    hideFilter: true
  },
  {
    facetName: "creatorGender",
    title: "Creator's Gender",
    isSearchable: false,
    compType: "list",
    desc: "Filter creators by gender of the creator.",
    placeHolder: "Select gender",
    fType: "creator",
  },
  {
    facetName: "creatorAge",
    title: "Creator's Age",
    isSearchable: false,
    compType: "inputRange",
    desc: "Filter creators by creator's age.",
    placeHolder: "Enter min/max age",
    fType: "creator",
  },
  {
    facetName: "creatorLanguage",
    title: "Creator's language",
    isSearchable: true,
    compType: "list",
    desc: "Filter creators by creators language.",
    type: "multiple",

    placeHolder: "Search Language",
    fType: "creator",
  },
  {
    facetName: "creatorType",
    title: "Creator Type",
    isSearchable: false,
    compType: "list",
    desc: "Filter creators by category",

    fType: "creator",
    placeHolder: "Search by creator category",
  },

  {
    facetName: "audienceLocations",
    title: "Audience Top Location",
    isSearchable: true,
    compType: "custom-multi-select",
    desc: "Filter creators who's audience is from the selected location.",

    placeHolder: "Search country or city",
    fType: "audience",
  },

  {
    facetName: "audienceAge",
    title: "Audience Age",
    isSearchable: true,
    compType: "custom-multi-select",
    desc: "Filter creators by audience age.",
    placeHolder: "Search age groups",
    fType: "audience",
  },
  {
    facetName: "audienceGender",
    title: "Audience Gender",
    isSearchable: true,
    compType: "custom-multi-select",
    desc: "Filter creators by gender of the audience.",

    placeHolder: "Search Gender",
    fType: "audience",
  },
  {
    facetName: "contentKeywords",
    title: "Keywords",
    isSearchable: true,
    compType: "list",
    desc: "Filter creators by keywords that can be found in creator's posts captions.",
    fType: "content",
    placeHolder: "Search by keyword",
    type: "tags",
  },
  {
    facetName: "recentPost",
    title: "Recent Post",
    isSearchable: false,
    compType: "list",
    desc: "Filter creators who posted content in the selected time frame. ",
    placeHolder: "Select time frame",
    fType: "content",
  },
  // {
  //   facetName: "totalPosts",
  //   title: "Total Posts",
  //   isSearchable: false,
  //   compType: "inputRange",
  //   desc: "Filter creators by total posts",

  //   placeHolder: "",
  //   fType: "content",
  // },
  {
    facetName: "avgViews",
    title: "Average Views",
    isSearchable: false,
    compType: "inputRange",
    desc: "Filter creators by minimum average reels views.",
    placeHolder: "Enter min/max views",
    fType: "performance",
  },
  {
    facetName: "engRate",
    title: "Engagement Rate",
    isSearchable: false,
    compType: "slider",
    desc: "Filter creators by engagement rates.",
    placeHolder: "Select engagement rate range",
    fType: "performance",
  },
  {
    facetName: "avgLikes",
    title: "Average Likes",
    isSearchable: false,
    compType: "inputRange",
    desc: "Filter creators by average likes.",
    placeHolder: "Enter min/max likes",
    fType: "performance",
  },
  // {
  //   facetName: "rating",
  //   title: "Rating",
  //   isSearchable: false,
  //   compType: "star",
  //   desc: "Filter creators by creator's rating",
  //   placeHolder: "Select rating",
  //   fType: "creator",
  // },
];

export const OtherFilters: ConfigType = [
  {
    facetName: "follower",
    title: "Followers",
    isSearchable: false,
    compType: "inputRange",
    desc: "Filter creators by follower count",
    placeHolder: "Enter min/max followers",
    fType: "creator",
    hideFilter: true
  },

  // {
  //   facetName: "category",
  //   title: "Category",
  //   isSearchable: false,
  //   compType: "list",
  //   desc: "Filter creators by category",

  //   fType: "creator",
  //   placeHolder: "Search by creator category",
  //   type: "tags",
  // },
  {
    facetName: "location",
    title: "Location",
    isSearchable: true,
    compType: "list",
    desc: "Filter creators by location",
    type: "multiple",
    fType: "creator",
    placeHolder: "Search location",
    hideFilter: true
  },
  // {
  //   facetName: "creatorType",
  //   title: "Creator Type",
  //   isSearchable: false,
  //   compType: "list",
  //   desc: "Filter creators by category",

  //   fType: "creator",
  //   placeHolder: "Search by creator category",
  // },

  {
    facetName: "creatorGender",
    title: "Creator's Gender",
    isSearchable: false,
    compType: "list",
    desc: "Filter creators by gender of the creator.",
    placeHolder: "Select gender",
    fType: "creator",
  },
  {
    facetName: "creatorAge",
    title: "Creator's Age",
    isSearchable: false,
    compType: "inputRange",
    desc: "Filter creators by creator's age.",
    placeHolder: "Enter min/max age",
    fType: "creator",
  },
  // {
  //   facetName: "rating",
  //   title: "Rating",
  //   isSearchable: false,
  //   compType: "star",
  //   desc: "Filter creators by creator's rating",
  //   placeHolder: "Select rating",
  //   fType: "creator",
  // },
];
export type ICustomFilter = { name: string; percentage: number };
export type IMinMaxFilter = { min?: number; max?: number };
export type IFilTerValue =
  | string
  | number
  | string[]
  | ICustomFilter[]
  | IMinMaxFilter
  | ICustomFilter
  | boolean;

export type IGetFaectValue = { [key: string]: { _id: string }[] };

export interface ICreator {
  _id: string;
  platform: string;
  username: string;
  link: string;
  name: string;
  dataSources: {};
  addedBy: string;
  addedByModelName: string;
  addedByType: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
  score: number;
  socialMediaObjectId: string;
  profilePicUrl: string;
  searchV1?: {
    [key: string]: any;
  };
}

export interface IGetCreators {
  data: ICreator[];
  pagination: IPagination;
}
